module.exports = __webpack_public_path__ + "static/img/default_avatar.d198b8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pickFault/default_avatar.png
// module id = HjKN
// module chunks = 33